// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"6df6411beb3eb4a8fca1","655":"d4328ef49de82c837dd7"}[chunkId] + ".js";
};